import { render } from "./LimitedsWithdraw.vue?vue&type=template&id=70253c02&scoped=true"
import script from "./LimitedsWithdraw.vue?vue&type=script&lang=js"
export * from "./LimitedsWithdraw.vue?vue&type=script&lang=js"

import "./LimitedsWithdraw.vue?vue&type=style&index=0&id=70253c02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70253c02"]])

export default __exports__